import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Page } from './page.model';

@Injectable()
export class PageFormService {
  constructor(private fb: FormBuilder) {}

  getForm(page: Page = new Page()): FormGroup {
    return this.fb.group({
      _id: [page._id],
      title: [page.title, Validators.required],
      anchor: [page.anchor, Validators.required],
      content: [page.content],
      metaDescription: [page.metaDescription],
      active: [page.active]
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/pages/shared/page-form.service.ts